import RequestAbstract from "./RequestAbstract";

export default class Auth extends RequestAbstract {
    async login(info = {}) {
        return await this.post(this.links.login, info);
    }

    async signup(info = {}) {
        return await this.post(this.links.signup, info);
    }

    async forgot(info = {}) {
        return await this.post(this.links.forgot, info);
    }

    async resendActivation(info = {}) {
        return await this.post(this.links.resendActivation, info);
    }

    async resetPassword(info = {}, token) {
        return await this.post(this.link + "auth/reset/" + token, info);
    }

    async logout(info = {}) {
        return await this.post(this.links.logout, info);
    }

    async google(info = {}) {
        return await this.post(this.link + "auth/google/token", info);
    }

    async apple(info = {}) {
        return await this.post(this.link + "auth/apple/token", info);
    }
}
